module.exports = __webpack_public_path__ + "static/media/body-bg.994bb276.jpg";